import socket from "socket.io-client";

export default class Socket {
  constructor(baseURL, getAccessToken) {
    // create socket
    this.io = socket(baseURL, {
      auth: (cb) => cb({ token: getAccessToken() }), // 보안: socket의 auth 필드이용해 토큰 전달 (query 로 사용하면 X)
    });

    this.io.on("connect_error", (err) => {
      console.log("socket error", err.message);
    });
  }

  onSync(event, callback) {
    if (!this.io.connected) {
      // socket 연결되지 않았다면 연결하기
      this.io.connect();
    }

    this.io.on(event, (message) => callback(message));
    return () => this.io.off(event); // 해당 event를 더이상 듣지 않도록 끌 수 있는 함수 리턴
    // 사용자가 이걸 가지고 있다가 끄고싶을때 리턴된 함수를 호출하면 됨
  }
}
